import React, { useMemo, useCallback } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	brandId: string;
	onChange: ({ brandId, value }: { brandId: string; value: Nullable<number> }) => void;
}

export const KmFeeField: React.FC<IProps> = React.memo(({ brandId, onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterKMFee') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			onChange({ brandId, value });
		},
		[onChange, brandId],
	);

	return (
		<FormInputNew
			testId="KMFee"
			name={`kmFee-${brandId}`}
			label="KMFeeLabel"
			type="number"
			min={0}
			max={100}
			precision={2}
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
});
